<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="支付记录"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
    </van-sticky>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
    <div 
      v-for="(item, index) in payList"
      :key="index">
      <van-cell-group
        style="margin: 1.2rem; text-align: left"
        inset
        v-show="item.allocatedAmount > 0"
      >
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
          {{ item.settlementBatchName }}
        </div>
        <div
          style="
            width: 0;
            height: 0;
            border: 4rem solid transparent;
            border-top: none;
            border-right-color: green;
            float: right;
            margin-top: -3rem;
            margin-right: 0.8rem;
            position: relative;
            margin-bottom: 0.4rem;
          "
        >
          <span
            style="
              position: absolute;
              width: 3rem;
              height: 4rem;
              line-height: 2rem;
              margin-left: 1.4rem;
              color: #fff;
              font-size: 0.8rem;
            "
            >已支付</span
          >
        </div>
        <van-field
          label="结算师傅名称"
          :value="item.userIdStr"
          input-align="right"
          readonly
          label-width="5.5rem"
        />
        <van-field
          label="公司"
          :value="item.companyName"
          input-align="right"
          readonly
          label-width="5rem"
        />

        <van-field
          label="支付类型"
          v-if="item.paymentTypeStr=='直接支付'"
          :value="item.paymentTypeStr"
          input-align="right"
          readonly
          label-width="5.5rem"
        />
        <van-cell
          v-else
          title="支付类型"
          title-style="color: #646566;"
          :value="item.paymentTypeStr"
          input-align="right"
          readonly
          label-width="5.5rem"
          value-class="text-color"
          isLink
          @click="seeDetail(item, '/merge-pay-records')"
        />
       
        <van-field
          label="收到金额（本单）"
          :value="item.allocatedAmount"
          input-align="right"
          readonly
          label-width="5.5rem"
        />
        <van-field
          label="支付金额"
          :value="item.paymentAmount"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="付款方式"
          :value="item.paymentMethod"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="支付凭证"
          :value="item.attachmentIds ? item.attachmentIds.split(',').length : '无'"
          input-align="right"
          readonly
          label-width="5rem"
          @click="seeFile(item)"
        />
        <van-field
          label="操作人"
          :value="item.createdByStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="操作时间"
          :value="item.updateTime"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="状态"
          :value="item.statusStr"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-field
          label="备注"
          :value="item.remarks"
          type="textarea"
          input-align="right"
          readonly
          label-width="5rem"
        />
        <van-row style="padding: 1rem">
            <van-col span="5.5">
              <van-button
                v-if="item.attachmentIds"
                type="default"
                size="small"
                @click="seeFile(item)"
                >查看支付凭证</van-button
              >
            </van-col>
        </van-row>
      </van-cell-group>
    </div>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "PaymentRecords",
  data() {
    return {
      loading: false,
      finished: false,
      payList: [],
      total: 0,
      page: 1,
    };
  },
  methods: {
    seeDetail(item, url) {
      this.$router.push({ path: url, query: { id: item.id } });
    },
    seeFile(item){
        this.$router.push({
          path:'/settlement/fileList',
          query:{
            attachmentIds:item.attachmentIds,
          }
        })
      },
    goback() {
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPayData();
    },
    getPayData(){
      this.axios({
        url:'/v1/web/settlement/payment-record/list',
        method:'post',
        data:{
          queryInfoParams:{
            settlementOrderId: this.$route.query.id,
          },
          size: 10,
          page: this.page
        }
      }).then(res=>{
        if(res.data.code == 200){
          if(this.page == 1){
            this.payList = res.data.data.list
          }else{
            this.payList = [...this.payList, ...res.data.data.list]
          }
            this.loading = false
            this.total = res.data.data.total
            if(this.payList.length >= this.total){
              this.finished = true
            }else{
              this.page++
            }
          }
      })
    },
  },
};
</script>
<style scoped>
.text-color {
  color: #3a96dd;
  font-weight: 700;
  text-decoration: underline;
}
</style>
